require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-coralis-jordan.json") })
        }
      }, "path---articles-tags-coralis-jordan");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-coralis-jordan!./.cache/json/articles-tags-coralis-jordan.json
// module id = 1772
// module chunks = 231608221292675